<template>
  <div>
    <v-tooltip bottom open-delay="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" @click="dialog_ativo = !dialog_ativo">
          <v-icon>mdi-settings</v-icon>
        </v-btn>
      </template>
      <span>Configuração do departamento</span>
    </v-tooltip>

    <v-dialog v-model="dialog_ativo" width="450" content-class="bra-20">
      <v-card>
        <v-card-title class="py-4">
          <span>Configuração do departamento</span>

          <v-spacer />

          <v-btn icon @click.stop="dialog_ativo = !dialog_ativo">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-3 pl-6">
          <TextFieldFormatadorDeValor
            label="Previsão de gatilho"
            v-model="configuracao.previsao_gatilho"
            outlined
            suffix="dias"
            :error-messages="PREVISAO_GATILHO_ERRORS"
            @focus="$event.target.select();"
            @keyup.enter="salvarConfiguracoes()"
          />

          <div>
            <v-switch v-model="configuracao.cobertura_manual" hide-details>
              <template #label>
                <span class="pl-2">Ativar cobertura manual</span>
              </template>
            </v-switch>

            <TextFieldFormatadorDeValor
              ref="refCoberturaDias"
              label="Cobertura de estoque"
              v-model="configuracao.cobertura_dias"
              class="mt-6"
              outlined
              suffix="dias"
              :disabled="!configuracao.cobertura_manual"
              :error-messages="COBERTURA_DIAS_ERRORS"
              @focus="$event.target.select();"
              @keyup.enter="salvarConfiguracoes()"
            />
          </div>
        </v-card-text>

        <v-card-actions class="mt-n4">
          <v-spacer />

          <v-btn color="primary" text @click="salvarConfiguracoes()">
            salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  buscarConfiguracoesDepartamento,
  salvarConfiguracoesDepartamento
} from "../../../api/compraPorDepartamentos/Departamento";
import {parametros_rota} from "./helpers/ParametrosRota";
import {logout} from "../../../helpers";
import {required, minValue} from "vuelidate/lib/validators";
import TextFieldFormatadorDeValor from "../../utils/TextFieldFormatadorDeValor";
import {mapGetters} from "vuex";
import {categoria_selecionada} from "./helpers/CategoriaSelecionado";

export default {
  name: "Configuracao",
  components: {
    TextFieldFormatadorDeValor
  },
  mixins: [parametros_rota, categoria_selecionada],
  data: () => ({
    dialog_ativo: false,
    configuracao: {
      previsao_gatilho: 0,
      cobertura_manual: false,
      cobertura_dias: 0
    }
  }),
  validations: {
    configuracao: {
      previsao_gatilho: {
        required,
        minValue:  minValue(1)
      },
      cobertura_dias: {
        required: function () {
          if (!this.configuracao.cobertura_manual) return true;
          return ![null, undefined].includes(this.configuracao.cobertura_dias);
        },
        minValue: function () {
          if (!this.configuracao.cobertura_manual) return true;
          return this.configuracao.cobertura_dias >= 1;
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      'callbackAtualizarTabelaCategorias': 'comprasPorDepartamentos/callbackAtualizarTabelaCategorias',
      'callbackAtualizarCardsTotais': 'comprasPorDepartamentos/callbackAtualizarCardsTotais'
    }),
    PREVISAO_GATILHO_ERRORS() {
      const errors = [];
      if (!this.$v.configuracao.previsao_gatilho.$dirty) return errors;
      !this.$v.configuracao.previsao_gatilho.required && errors.push("Campo Obrigatório.");
      !this.$v.configuracao.previsao_gatilho.minValue && errors.push("Valor mínimo é 1.");
      return errors;
    },
    COBERTURA_DIAS_ERRORS() {
      const errors = [];
      if (!this.$v.configuracao.cobertura_dias.$dirty) return errors;
      !this.$v.configuracao.cobertura_dias.required && errors.push("Campo Obrigatório.");
      !this.$v.configuracao.cobertura_dias.minValue && errors.push("Valor mínimo é 1.");
      return errors;
    }
  },
  watch: {
    dialog_ativo(valor) {
      if (valor) {
        this.buscarConfiguracoesDepartamento();
      } else {
        this.$v.$reset();
      }
    }
  },
  methods: {
    buscarConfiguracoesDepartamento() {
      this.$store.dispatch("loading/addRequisicao",
        buscarConfiguracoesDepartamento(this.departamento_compra)
          .then(config => (this.configuracao = config))
          .catch(logout)
      );
    },
    salvarConfiguracoes() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const requisicao = {
        ...this.configuracao,
        id_departamento: this.departamento_compra,
        grupo: this.grupo_compra,
      };

      this.$store.dispatch("loading/addRequisicao",
        salvarConfiguracoesDepartamento(requisicao)
          .then(() => {
            this.dialog_ativo = false;
            this.callbackAtualizarTabelaCategorias();
            this.callbackAtualizarCardsTotais();
            this.categoria_selecionada = null;
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>

</style>
